// extracted by mini-css-extract-plugin
export default {"modalContent":"delete-plan-modal_modalContent__ohrMJ","bodyText":"delete-plan-modal_bodyText__bNq0Y"};